import { render, staticRenderFns } from "./ShuttersType.vue?vue&type=template&id=7041812c&scoped=true"
import script from "./ShuttersType.vue?vue&type=script&lang=ts"
export * from "./ShuttersType.vue?vue&type=script&lang=ts"
import style0 from "./ShuttersType.vue?vue&type=style&index=0&id=7041812c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7041812c",
  null
  
)

export default component.exports